import * as React from 'react';
import Helper from '../../../../core/libraries/Helper';
import Constants from '../../../../core/libraries/Constants';
import RbLabel from '../../../../bosch-react/components/label/RbLabel';
import { ISearchResultItem } from '../../types';
import { RootState } from '../../../../store/store';

interface IProps {
  searchItem: ISearchResultItem;
} 

class Search_HoverPanel extends React.Component<IProps, any> {

    constructor(props: any) {
        super(props);

        this.renderHeader = this.renderHeader.bind(this);
        this.renderReportType = this.renderReportType.bind(this);
        this.renderKeywords = this.renderKeywords.bind(this);
        this.renderAbstract = this.renderAbstract.bind(this);
        // RnD
        this.renderDocumentNumber = this.renderDocumentNumber.bind(this);
        // LL
        this.renderPlantorBU = this.renderPlantorBU.bind(this);
        this.renderProcessorProduct = this.renderProcessorProduct.bind(this);
        //Thesis - None
        // Paper
        this.renderConferenceName = this.renderConferenceName.bind(this);
        this.renderConferenceLocation = this.renderConferenceLocation.bind(this);
        this.renderConferenceDate = this.renderConferenceDate.bind(this);
        this.renderJournalName = this.renderJournalName.bind(this);
        this.renderPublicationDate = this.renderPublicationDate.bind(this);
    }

    render() {
        let displayBlock = <span />
        switch (this.props.searchItem.UploadType) {
            case Constants.UPLOAD_TYPE.RnD: {
                displayBlock = <div className="ms-Grid" style={{ padding: "0px 20px" }}>
                    {this.renderHeader()}
                    {this.renderKeywords()}
                    {this.renderAbstract()}
                    {this.renderReportType()}
                    {this.renderDocumentNumber()}
                    <br />
                </div>;
                break;
            }
            case Constants.UPLOAD_TYPE.LL: {
                displayBlock = <div className="ms-Grid" style={{ padding: "0px 20px" }}>
                    {this.renderHeader()}
                    {this.renderKeywords()}
                    {this.renderAbstract()}
                    {this.renderReportType()}
                    {this.renderProcessorProduct()}
                    {this.renderPlantorBU()}
                    <br />
                </div>;
                break;
            }
            case Constants.UPLOAD_TYPE.Thesis: {
                displayBlock = <div className="ms-Grid" style={{ padding: "0px 20px" }}>
                    {this.renderHeader()}
                    {this.renderKeywords()}
                    {this.renderAbstract()}
                    {this.renderReportType()}
                    <br />
                </div>;
                break;
            }
            case Constants.UPLOAD_TYPE.Paper: {
                let choiceBlock = <span />
                switch (this.props.searchItem.DocumentType) {
                    case "Conference Paper": {
                        choiceBlock = <div>
                            {this.renderConferenceName()}
                            {this.renderConferenceLocation()}
                            {this.renderConferenceDate()}
                        </div>;
                        break;
                    }
                    case "Journal Paper": {
                        choiceBlock = <div>
                            {this.renderJournalName()}
                            {this.renderPublicationDate()}
                        </div>;
                        break;
                    }
                }
                displayBlock = <div className="ms-Grid" style={{ padding: "0px 20px" }}>
                    {this.renderHeader()}
                    {this.renderKeywords()}
                    {this.renderAbstract()}
                    {this.renderReportType()}
                    {choiceBlock}
                    <br />
                </div>;
                break;
            }
        }
        return displayBlock;
    }

    renderHeader() {
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel isInline={false}><b>{this.props.searchItem.Title}</b></RbLabel>
                <RbLabel isInline={false}>{this.props.searchItem.Department}</RbLabel>
            </div >
        );
    }

    renderReportType() {
        let documentType =this.props.searchItem.DocumentType
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Report type :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={5}>{documentType}</RbLabel>
            </div>
        );
    }

    renderKeywords() {
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Keywords :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={8}>{this.props.searchItem.Keywords}</RbLabel>
            </div>
        );
    }

    renderAbstract() {
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Abstract :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={8}>{this.props.searchItem.Abstract}</RbLabel>
            </div>
        );
    }

    // RnD
    renderDocumentNumber() {
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Report number :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={5}>{this.props.searchItem.DocumentNumber}</RbLabel>
            </div>
        );
    }

    // LL
    renderPlantorBU() {
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Plant/BU :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={5}>{this.props.searchItem.PlantorBU}</RbLabel>
            </div>
        );
    }
    renderProcessorProduct() {
        let value = this.props.searchItem.Product;
        if (value === "") {
            value = this.props.searchItem.Process;
        }
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Process/Product :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={5}>{value}</RbLabel>
            </div>
        );
    }

    // Thesis - None

    // Paper
    renderConferenceName() {
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Name of conference :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={5}>{this.props.searchItem.NameOfConference}</RbLabel>
            </div>
        );
    }

    renderConferenceLocation() {
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Location of conference :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={5}>{this.props.searchItem.LocationOfConference}</RbLabel>
            </div>
        );
    }

    renderConferenceDate() {
        const conferenceDate = !!this.props.searchItem.DateOfConference ? new Date(this.props.searchItem.DateOfConference) : null   ;
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Date of conference :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={5}>{Helper.getDateTimeFormatForUI(conferenceDate)}</RbLabel>
            </div>
        );
    }

    renderJournalName() {
        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Name of journal :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={5}>{this.props.searchItem.NameOfJournal}</RbLabel>
            </div>
        );
    }

    renderPublicationDate() {
        const dateOfPublication = !!this.props.searchItem.DateOfPublication ? new Date(this.props.searchItem.DateOfPublication) : null   ;

        return (
            <div className="ms-Grid-row search-hover-row">
                <RbLabel>Date of publication :</RbLabel>
                <RbLabel isMultipleLines={true} maxLines={5}>{Helper.getDateTimeFormatForUI(dateOfPublication)}</RbLabel>
            </div>
        );
    }

}

export default Search_HoverPanel;